import { render, staticRenderFns } from "./activity_num.vue?vue&type=template&id=7489812b&scoped=true&"
import script from "./activity_num.vue?vue&type=script&lang=js&"
export * from "./activity_num.vue?vue&type=script&lang=js&"
import style0 from "./activity_num.vue?vue&type=style&index=0&id=7489812b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7489812b",
  null
  
)

export default component.exports